import { Flex, Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { Userpilot } from "userpilot";
import { ControlledMantineEditNumberInput } from "../../../../../mantine/mrt/components/edit/ControlledMantineEditNumberInput";
import { submitOrCancelOnKeyPress } from "../../../../../mantine/mrt/utils/submitOrCancelOnKeyPress";
import { RoundedNumberFormat } from "../../../../../utils/RoundedNumberFormat";
import type { EnergyRevenuesCellCheckStateResponse } from "../../../RevenueMonitoring.types";
import { getDiff } from "../../utils/getDiff";

export function getUserProvidedAmountColumn(
  errorText?: string
): MRT_ColumnDef<EnergyRevenuesCellCheckStateResponse> {
  return {
    header: "Prüfwert",
    accessorKey: "user_provided_amount",
    Cell: ({ cell, row }) => {
      const userProvidedAmount =
        cell.getValue<
          EnergyRevenuesCellCheckStateResponse["user_provided_amount"]
        >();

      if (typeof userProvidedAmount !== "number") {
        return null;
      }

      const { tooltipLabel } = getDiff({
        originalValue: row.original.calculated_amount,
        targetValue: userProvidedAmount
      });

      return (
        <Flex justify="flex-end">
          <Tooltip label={tooltipLabel}>
            <div>
              <RoundedNumberFormat
                decimalScale={2}
                decimalSeparator=","
                displayType="text"
                fixedDecimalScale={true}
                thousandSeparator="."
                value={userProvidedAmount}
              />
            </div>
          </Tooltip>
        </Flex>
      );
    },
    mantineTableHeadCellProps: {
      className: "th-rightaligned"
    },
    Edit: ({ cell, column, row, table }) => {
      return (
        <ControlledMantineEditNumberInput
          cell={cell}
          columnId={column.id}
          errorText={errorText}
          label="Prüfwert"
          placeholder="Prüfwert"
          row={row}
          storeAsNumber
          onClick={() => Userpilot.track("em_prufansicht_prufwert_feld")}
          onKeyDown={(event) => submitOrCancelOnKeyPress(event, table)}
        />
      );
    },
    filterVariant: "range",
    size: 140
  };
}
